import * as React from 'react'
import { Header, HeaderRow, IconImage, IconWrapper, Name, Position, Text, TextContent, Wrapper } from './styled'
import { TestimonialSliderItemProps } from './types'

export const TestimonialSliderItem = ({
  image,
  name,
  position,
  quote,
  enforceRoundImage = false,
}: TestimonialSliderItemProps) => {
  return (
    <Wrapper>
      <Header>
        <HeaderRow>
          {image && image.filename && (
            <IconWrapper $hasRoundImage={enforceRoundImage}>
              <IconImage src={image.filename} alt={image.alt || image.name} />
            </IconWrapper>
          )}
          <TextContent>
            <Name>{name}</Name>
            <Position>{position}</Position>
          </TextContent>
        </HeaderRow>
      </Header>
      <Text>{quote}</Text>
    </Wrapper>
  )
}
